import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "bridge",
  "use": "bridge-usage",
  "viewBox": "0 0 227 57",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 227 57\" id=\"bridge\"><path fill=\"#EB1C23\" d=\"M1.77 2.95h225.2v7.1H1.77z\" /><path d=\"M113.46 56.45a34.02 34.02 0 0 0-68.03 0m176.76 0a34.02 34.02 0 1 0-68.03 0\" stroke=\"#EB1C23\" stroke-width=\"8\" /><path d=\"M72.77 56.45a34.02 34.02 0 1 0-68.03 0m176.76 0a34.02 34.02 0 1 0-68.04 0\" stroke=\"#EB1C23\" stroke-width=\"8\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol